import { Platform } from '@angular/cdk/platform';
import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Button } from '../../../components/common/button/button';
import { AuthApiService } from '../../../services/apis/auth-api.service';
import { ApiException, ApiStatus } from '../../../services/apis/status';
import { MessageService } from '../../../services/message.service';
import { TitleService } from '../../../services/title.service';

@Component({
  selector: 'app-signup-sent-page',
  imports: [Button, RouterModule],
  templateUrl: './signup-sent-page.html',
  styleUrl: './signup-sent-page.scss',
})
export class SignupSentPage {
  email: string = '';
  loading: boolean = false;
  timeout: number = 60;
  interval?: NodeJS.Timeout;
  constructor(
    private titleService: TitleService,
    private route: ActivatedRoute,
    private authApi: AuthApiService,
    private messageService: MessageService,
    private router: Router,
    private platform: Platform
  ) {
    this.titleService.setTitle('Please verify your email');
    this.route.queryParams.subscribe((params) => {
      this.email = params['email'] ?? '';
      this.startTimer();
    });
  }
  startTimer() {
    if (!this.platform.isBrowser) {
      return;
    }
    clearInterval(this.interval);
    this.timeout = 60;
    this.interval = setInterval(() => {
      this.timeout -= 1;
      if (this.timeout <= 0) {
        clearInterval(this.interval);
        this.interval = undefined;
      }
    }, 1000);
  }

  async resend() {
    if (!this.email) {
      return;
    }
    try {
      this.loading = true;
      const r = await this.authApi.rensendSignupEmail(this.email);
      if (r) {
        this.messageService.open('Verification email sent', 'OK');
        this.startTimer();
      } else {
        this.messageService.open(
          'Failed to send email, please try again later',
          'OK'
        );
      }
    } catch (error) {
      if (error instanceof ApiException) {
        if (error.status === ApiStatus.USER_EMAIL_NOT_FOUND) {
          this.messageService
            .open('This email is not registered', 'Signup')
            ?.onAction()
            .subscribe(() => {
              this.router.navigate(['/signup'], { replaceUrl: true });
            });
        } else if (error.status === ApiStatus.USER_EMAIL_SEND_TOO_FREQUENTLY) {
          this.messageService.open(
            'Email sent too frequently, please try again later',
            'OK'
          );
          this.startTimer();
        }
      }
    } finally {
      this.loading = false;
    }
  }
}
